export default "__VITE_ASSET__zAY4t43___"